var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1029_1446",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5858 1.41421C11.3668 0.633165 12.6332 0.633165 13.4142 1.41421L23.3137 11.3137L12 22.6274L0.686292 11.3137L10.5858 1.41421Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5858 1.41421C11.3668 0.633165 12.6332 0.633165 13.4142 1.41421L23.3137 11.3137L12 22.6274L0.686292 11.3137L10.5858 1.41421Z",
    fill: "#F6F7F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87868 0.707107C11.0503 -0.464466 12.9497 -0.464466 14.1213 0.707107L24.0208 10.6066L22.6066 12.0208L12.7071 2.12132C12.3166 1.7308 11.6834 1.7308 11.2929 2.12132L9.87868 0.707107ZM12 22.6274L0.686292 11.3137L12 22.6274ZM-0.0208151 10.6066L9.87868 0.707107C11.0503 -0.464466 12.9497 -0.464466 14.1213 0.707107L12.7071 2.12132C12.3166 1.7308 11.6834 1.7308 11.2929 2.12132L1.3934 12.0208L-0.0208151 10.6066ZM23.3137 11.3137L12 22.6274L23.3137 11.3137Z",
    fill: "#879CC2",
    mask: "url(#path-1-inside-1_1029_1446)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipArrow);
export default __webpack_public_path__ + "static/media/tooltip_arrow.cb5de970ef837af02f8ea1f5943b1549.svg";
export { ForwardRef as ReactComponent };